<template>
  <div class="mine pointer">
    <div class="mineContent">
      <div class="setBox">
        <img
          @click="toSetCenter"
          class="mineSet"
          src="@/assets/icons/mineSet.png"
          alt=""
        />
        <div @click="toMessageCenter" class="mine_right_xiaoxi">
          <van-badge :content="count" max="99" v-if="count > 0">
            <img
              class="mineSet"
              src="@/assets/icons/messageNotification.png"
              alt=""
            />
          </van-badge>
          <img
            v-else
            class="mineSet"
            src="@/assets/icons/messageNotification.png"
            alt=""
          />
        </div>
      </div>
      <div class="userinfoBox" @click="toPersonalCenter">
        <img
          class="avatar"
          :src="
            token
              ? userinfo.avatar
                ? userinfo.avatar
                : require('@/assets/icons/defaultAvatar.png')
              : require('@/assets/icons/defaultAvatar.png')
          "
          alt=""
        />
        <div class="nameOfId">
          <p class="userName">
            {{ token ? maskPhoneRegex(userinfo.phoneNumber) : "点击登录" }}
          </p>
          <div class="ueseId">
            <div v-if="token">ID:</div>
            <div>{{ token ? userinfo.id : "体验更多精彩内容" }}</div>
            <img
              class="copyIcon"
              v-if="token"
              @click.stop="issucopy"
              src="../../assets/icons/copy.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="serviceBox" @click="contactService">
        <div class="serviceName">Hi，有什么可以帮您</div>
        <div class="Icons">
          <div>
            <img class="serviceIcon" src="@/assets/icons/service.png" alt="" />
            <img
              class="arrows_rigth"
              src="@/assets/icons/arrows-rigth.png"
              alt=""
            />
          </div>
          <div class="timeQuantum">工作时间:早9:00-晚7:00</div>
        </div>
      </div>
      <div class="ul">
        <div
          class="li"
          @click="handleTool(item.code)"
          v-for="item in toolList"
          :key="item.code"
        >
          <img :src="item.icon" alt="" />
          <p>{{ item.name }}</p>
        </div>
      </div>
    </div>
    <AochenFooter></AochenFooter>
    <detainmentDialog
      v-model="showDialog"
      width="298"
      confimText="确认"
      cancelText="取消"
      cancelType="primary"
      @confim="confirmModel"
      @change="changeModel"
      title="请选择激活码使用类型"
    >
      <div class="contentBox">
        <div
          v-for="(item, index) in typeOptional"
          :key="index"
          :class="['typeItem', typeActive == index ? 'typeActive' : '']"
          @click="typeActive = index"
        >
          {{ item.label }}
        </div>
      </div>
    </detainmentDialog>
  </div>
</template>

<script>
import { sysConfigByConfigKey, unread } from "@/api/index.js";
import { Toast } from "vant";
import AochenFooter from "@/components/AochenFooter";
import detainmentDialog from "@/components/publicDialog/detainmentDialog.vue";
export default {
  name: "Mine",
  components: {
    AochenFooter,
    detainmentDialog,
  },
  data() {
    return {
      userinfo: JSON.parse(this.$store.getters.data),
      token: this.$store.getters.token,
      toolList: [
        {
          icon: require("@/assets/icons/JHM.png"),
          name: "激活码",
          code: "JHM",
        },
        {
          icon: require("@/assets/icons/SQ.png"),
          name: "云手机授权",
          code: "SQ",
        },
        {
          icon: require("@/assets/icons/DDJL.png"),
          name: "订单记录",
          code: "DDJL",
        },
        {
          icon: require("@/assets/icons/ZY.png"),
          name: "云手机转移",
          code: "ZY",
        },
        {
          icon: require("@/assets/icons/SZ.png"),
          name: "云手机设置",
          code: "SZ",
        },
        {
          icon: require("@/assets/icons/proxyIp.png"),
          name: "代理IP",
          code: "DLIP",
        },
      ],
      count: 0,
      showDialog: false,
      typeOptional: [
        {
          label: "新增云手机",
          value: "0",
        },
        {
          label: "续时云手机",
          value: "1",
        },
      ],
      typeActive: 0,
    };
  },
  mounted() {
    this.activityEnd();
  },
  computed: {
    maskPhoneRegex: {
      get() {
        return function (phone) {
          return phone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
        };
      },
    },
  },
  methods: {
    // 复制
    issucopy() {
      this.$common.copy(this.userinfo.id, "复制成功!");
    },
    handleTool(code) {
      this.$auth.checkLogin(
        () => {
          switch (code) {
            case "JHM":
              this.showDialog = true;
              break;
            case "SQ":
              this.$router.push("/equipmentauthorization");
              break;
            case "DDJL":
              this.$router.push("/purchaserecord");
              break;
            case "ZY":
              this.$router.push("/equipmentShift");
              break;
            case "SZ":
              this.$router.push("/cloudPhoneSetup");
              break;
            case "DLIP":
              this.$router.push("/proxyIp");
              break;
            default:
              break;
          }
        },
        this.$router,
        this.$store.getters.token
      );
    },
    toSetCenter() {
      this.$auth.checkLogin(
        () => {
          this.$router.push("/setCenter");
        },
        this.$router,
        this.$store.getters.token
      );
    },
    toMessageCenter() {
      this.$auth.checkLogin(
        () => {
          this.$router.push("/messageCenter");
        },
        this.$router,
        this.$store.getters.token
      );
    },
    toPersonalCenter() {
      this.$auth.checkLogin(
        () => {
          this.$router.push("/personalCenter");
        },
        this.$router,
        this.$store.getters.token
      );
    },
    contactService() {
      sysConfigByConfigKey({ configKey: "wx_kf_url" }).then((res) => {
        if (res.code == 200) {
          window.location.href = `https://work.weixin.qq.com/kfid/${res.data}`;
        }
      });
    },
    // 活动结束
    activityEnd() {
      unread().then((res) => {
        if (res.code == 200) {
          this.count = res.data.count;
        }
      });
    },
    confirmModel() {
      if (this.typeActive == 0) {
        this.$router.push({
          path: "/activationcodeusage",
          query: { type: 0 },
        });
      }
      if (this.typeActive == 1) {
        this.$router.push({
          path: "/activationcodeusage",
          query: { type: 1 },
        });
      }
    },
    changeModel() {},
  },
};
</script>

<style lang="less" scoped>
.mine {
  font-family: MiSans, MiSans;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #e1e1fe 0%, #f5f7fb 100%);
  overflow: auto;
  padding-bottom: 65px;
  .mineContent {
    padding: 0 17px;
  }
  .setBox {
    display: flex;
    flex-direction: row-reverse;
    padding: 12px 0;
    .mineSet {
      width: 25px;
      height: 25px;
    }
    .mine_right_xiaoxi {
      margin-right: 10px;
    }
  }
  .userinfoBox {
    text-align: left;
    display: flex;
    width: 100%;
    .avatar {
      width: 50px;
      height: 50px;
      border-radius: 50px;
    }
    .nameOfId {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      margin-left: 17px;
      .userName {
        font-weight: 600;
        font-size: 19px;
        color: #303332;
      }
      .ueseId {
        font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
        font-weight: 400;
        font-size: 13px;
        color: #7e859a;
        display: flex;
        align-items: center;
        .copyIcon {
          width: 15px;
          height: 15px;
        }
      }
    }
  }
  .serviceBox {
    width: 100%;
    height: 54px;
    background: #fff;
    border-radius: 10px;
    margin-top: 25px;
    padding: 0 8px 0 17px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .timeQuantum {
      font-size: 12px;
      font-weight: 500;
    }
    .serviceName {
      font-weight: 600;
      font-size: 15px;
      color: #303332;
    }
    .Icons {
      display: flex;
      align-items: flex-end;
      flex-direction: column;
      .serviceIcon {
        width: 56px;
        height: 56px;
        margin-top: -30px;
        margin-right: 17px;
      }
      .arrows_rigth {
        width: 17px;
        height: 17px;
      }
    }
  }
  .ul {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    // gap: 20px;
    row-gap: 20px;
    margin-top: 17px;
    background: #fff;
    border-radius: 13px;
    padding: 21px 17px;
    .li {
      img {
        width: 33px;
      }
      p {
        font-weight: 500;
        font-size: 13px;
        color: #505465;
        margin-top: 5px;
      }
    }
  }
}
.contentBox {
  .typeItem {
    height: 42px;
    line-height: 42px;
    font-weight: 600;
    font-size: 14px;
    color: #505465;
  }
  .typeActive {
    background: #f0edfe;
    color: #886df3;
  }
}
</style>